var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fillRule: "nonzero",
    fill: "rgb(97.254902%,41.568627%,41.568627%)",
    d: "m15.45313,27.27344l-4.08985,0l0,-24.54688l4.08985,0c0.7539,0 1.36328,-0.60937 1.36328,-1.36328c0,-0.7539 -0.60938,-1.36328 -1.36328,-1.36328l-10.90625,0c-0.75391,0 -1.36329,0.60938 -1.36329,1.36328c0,0.75391 0.60938,1.36328 1.36329,1.36328l4.08984,0l0,24.54688l-4.08984,0c-0.75391,0 -1.36329,0.60937 -1.36329,1.36328c0,0.75391 0.60938,1.36328 1.36329,1.36328l10.90625,0c0.7539,0 1.36328,-0.60937 1.36328,-1.36328c0,-0.75391 -0.60938,-1.36328 -1.36328,-1.36328zm0,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.2cfa9e5cc511a8aa5d87d57bc28a21bb.svg";
export { ForwardRef as ReactComponent };